import { Icon } from '@/icon/Icon';
import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import type { Row as TRow, Table } from '@tanstack/react-table';
import CountBubble from '../../../CountBubble';
import { BodyCell } from '../../components/BodyCell';
import { useDataProvider } from '../../DataProviderContext';

const Cell = styled(BodyCell, { name: 'GroupRow', slot: 'Cell' })(
  ({ theme }) => ({
    backgroundColor: theme.palette.getGrey(20),
    padding: theme.spacing(1, 2),
    cursor: 'pointer',
  })
);

const Content = styled('div', { name: 'GroupRow', slot: 'Content' })(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  })
);

const HeaderContainer = styled('div', {
  name: 'GroupRow',
  slot: 'HeaderContainer',
})({
  display: 'flex',
  alignItems: 'center',
});

const isRowSelectionEnabled = (table: Table<unknown> | undefined) =>
  Boolean(table?.options.enableRowSelection);

const getColSpan = (row: TRow<unknown>) => row.getVisibleCells().length;

export interface GroupHeaderRowProps {
  row: TRow<any>;
}

export const GroupRow = ({ row }: GroupHeaderRowProps) => {
  const { table } = useDataProvider();

  return (
    <TableRow key={row.id} className="group">
      {isRowSelectionEnabled(table) && <Cell />}
      <Cell
        colSpan={getColSpan(row)}
        onClick={() => row.toggleExpanded(!row.getIsExpanded())}
      >
        <Content>
          <HeaderContainer>
            <Typography variant="button">
              {typeof row.groupingValue === 'string' && row.groupingValue}
            </Typography>
            <CountBubble badgeContent={row.subRows.length} color="primary" />
          </HeaderContainer>
          <Icon name={row.getIsExpanded() ? 'expand_less' : 'expand_more'} />
        </Content>
      </Cell>
    </TableRow>
  );
};
